export const GET_LIKES = "GET_LIKES";
export const GET_LIKES_FULFILLED = "GET_LIKES_FULFILLED";
export const GET_LIKES_REJECTED = "GET_LIKES_REJECTED";
export const GET_USERS_DATA_SUCCESS = "GET_USERS_DATA_SUCCESS";
export const GET_USERS_DATA = "GET_USERS_DATA";
export const CHECK_ALREADY_LIKED = "CHECK_ALREADY_LIKED";
export const LIKE_SHARE = "LIKE_SHARE";
export const LIKE_SHARE_SUCCESS = "LIKE_SHARE_SUCCESS";
export const UNLIKE_SHARE = "UNLIKE_SHARE";
export const UNLIKE_SHARE_SUCCESS = "UNLIKE_SHARE_SUCCESS";
export const GET_USERS_DATA_FAILURE = "GET_USERS_DATA_FAILURE";
export const GET_COMMENTS = "GET_COMMENTS";
export const GET_COMMENTS_SUCCESS = "GET_COMMENTS_SUCCESS";
export const GET_COMMENTS_FAILURE = "GET_COMMENTS_FAILURE";
export const ADD_COMMENT = "ADD_COMMENT";
export const ADD_COMMENT_SUCCESS = "ADD_COMMENT_SUCCESS";
export const ADD_COMMENT_FAILURE = "ADD_COMMENT_FAILURE";
export const ON_CHANGE = "ON_CHANGE";
export const LIKE_COMMENT = "LIKE_COMMENT";
export const UNLIKE_COMMENT = "UNLIKE_COMMENT";
export const UNLIKE_COMMENT_SUCCESS = "UNLIKE_COMMENT_SUCCESS";
export const LIKE_COMMENT_SUCCESS = "LIKE_COMMENT_SUCCESS";
export const DELETE_COMMENT = "DELETE_COMMENT";
export const DELETE_COMMENT_SUCCESS = "DELETE_COMMENT_SUCCESS";
export const UPDATE_COMMENT_CHANGE = "UPDATE_COMMENT_CHANGE";
export const ONCHANGE_UPDATE_COMMENT = "ONCHANGE_UPDATE_COMMENT";
export const EDIT_COMMENT = "EDIT_COMMENT";
export const EDIT_COMMENT_SUCCESS = "EDIT_COMMENT_SUCCESS";
export const SET_UPDATING_COMMENT = "SET_UPDATING_COMMENT";
export const GET_SHARE_SERVICE_URL = "GET_SHARE_SERVICE_URL";
export const GET_SHARE_SERVICE_URL_SUCCESS = "GET_SHARE_SERVICE_URL_SUCCESS";
export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const GET_COMMENT_COUNT_SUCCESS = "GET_COMMENT_COUNT_SUCCESS";
export const GET_COMMENT_COUNT = "GET_COMMENT_COUNT";
export const UPDATE_COMMENT_COUNT = "UPDATE_COMMENT_COUNT";
